import i18n from '@/vue/languages';

export const vrmInstallationAccessLevel = {
    MONITORING: 0,
    FULL_CONTROL: 1,
    SITE_SHARE: 2,
    TECHNICIAN: 3,
};

export const accessLevelDropdownOptions = [
    {
        name: i18n.t('users.user_read_only', { i18nFallback: 'User (read only)' }),
        accessLevel: vrmInstallationAccessLevel.MONITORING,
    },
    {
        name: i18n.t('users.technician', { i18nFallback: 'Technician' }),
        accessLevel: vrmInstallationAccessLevel.TECHNICIAN,
    },
    {
        name: i18n.t('users.owner', { i18nFallback: 'Admin' }),
        accessLevel: vrmInstallationAccessLevel.FULL_CONTROL,
    },
];

export const findAccessLevelOption = accessLevel => {
    return accessLevelDropdownOptions.find(option => option.accessLevel === accessLevel);
};

export const accessLevelDropdownOptionsFiltered = installation => {
    return accessLevelDropdownOptions.filter(option => {
        // only show FULL_CONTROL and TECHNICIAN if user has permission to alter installation
        if (
            option.accessLevel === vrmInstallationAccessLevel.FULL_CONTROL ||
            option.accessLevel === vrmInstallationAccessLevel.TECHNICIAN
        ) {
            return installation.view_permissions.canAlterInstallation;
        }
        return true;
    });
};

export const userOnTeamsAccessLevelsOptions = [
    {
        name: i18n.t('teams.admin', { i18nFallback: 'Admin' }),
        isAdmin: 1,
    },
    {
        name: i18n.t('teams.member', { i18nFallback: 'Member' }),
        isAdmin: 0,
    },
];

export const findUserOnTeamsAccessLevelOption = isAdmin => {
    return userOnTeamsAccessLevelsOptions.find(option => option.isAdmin === isAdmin);
};

export const teamMembersAccessLevel = {
    USER: 0,
    TEAM_ADMIN: 1,
};
